// actions/pubsub/add.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function addHasErrored(bool) {
  return {
    type: 'ADD_HAS_ERRORED',
    hasErrored: bool
  };
}

export function addIsLoading(bool) {
  return {
    type: 'ADD_IS_LOADING',
    isLoading: bool
  };
}

export function addFetchDataSuccess(response) {
  return {
    type: 'ADD_FETCH_DATA_SUCCESS',
    response
  };
}

export function addFetchData(host, params) {
  return (dispatch) => {
    dispatch(addIsLoading(true));
    dispatch(addHasErrored(false));
    fetch(host + 'admin/add', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(addFetchDataSuccess(result));
            PubSub.publish('pubsub.list.reload', true);
          })
          .catch(() => dispatch(addHasErrored(true)));
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(addHasErrored(true));
      dispatch(addIsLoading(false));
    });
  };
}